// src/components/layout/ProtectedLayout.js
import React from 'react';
import ProtectedRoute from '../common/ProtectedRoute';
import Layout from './Layout';

const ProtectedLayout = ({ children, darkMode, setDarkMode }) => {
  return (
    <ProtectedRoute>
      <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
        {children}
      </Layout>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;